/**
 * Created by hp on 2017/5/27.
 */
const defaults = {
    showAudioArea: false,
    height: Math.ceil(Math.min(480, window.innerWidth || screen.width) * 1080 / 1920),
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'SHOW_AUDIO_AREA':
            return {...state, showAudioArea: true};
        case 'HIDE_AUDIO_AREA':
            return {...state, showAudioArea: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/audioArea.js